import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  strapiCreateUserType,
  strapiDeleteUserType,
  strapiUpdateUserType,
  type StrapiUserTypeInput,
} from '../../api/strapiUserTypes';
import { queryKeys } from '../queryKeys';

export function useCreateUserTypeMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: StrapiUserTypeInput) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiCreateUserType(jwt, input);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.userTypes(jwt) });
    },
  });
}

export function useUpdateUserTypeMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      documentId,
      ...patch
    }: { documentId: string } & Partial<StrapiUserTypeInput>) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiUpdateUserType(jwt, documentId, patch);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.userTypes(jwt) });
    },
  });
}

export function useDeleteUserTypeMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (documentId: string) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiDeleteUserType(jwt, documentId);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.userTypes(jwt) });
    },
  });
}
